import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GeocodingResult } from '../geocoding-result.model';
import { HttpUtils } from '../http-utils';
import { URL_BASE } from '../../core/constants';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {

  private GEOCODING_URI = 'routing/geolocation/ip';

  constructor(private http: HttpClient) {
  }

  public ipGeoloc(): Observable<GeocodingResult> {
    const headers = HttpUtils.createHeaders();

    return this.http.get<GeocodingResult>(`${URL_BASE}/api/${this.GEOCODING_URI}`, { headers })
  }
}
